<div class="ag-tooltip select-text whitespace-nowrap">
  @if (!detectedAt) {
    <div>Not yet detected</div>
  } @else {
    <div>IP: {{ params.data?.ip_address ?? 'N/A' }}</div>
    <div>DNS: {{ params.data?.dns_hostname ?? 'N/A' }}</div>
    <div>Detected: {{ detectedAt }}</div>
  }
</div>
